// extracted by mini-css-extract-plugin
module.exports = {"loader":"ra-loader_loader__XGLFj","l7":"ra-loader_l7__GXp0V"};